import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@assets/components/ui/select";
import classNamesLib from "classnames";
import { CSSProperties } from "react";
import {
  Control,
  Controller,
  FieldErrors,
  FieldValues,
  Path,
} from "react-hook-form";
import selectStyles from "./select.module.scss";

export type SelectOption = {
  value: string;
  text: string;
  disabled?: boolean;
};

interface Props<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  options: SelectOption[];
  value?: string | null;
  styles?: CSSProperties;
  placeholder?: string;
  classNames?: {
    warpper?: string;
    trigger?: string;
    content?: string;
    error?: string;
    label?: string;
  };
  label?: string;
  disabled?: boolean;
  clearable?: boolean;
}

export const CustomSelect = <T extends FieldValues>({
  name,
  label,
  control,
  options,
  placeholder,
  styles,
  classNames,
  disabled = false,
  clearable = false,
}: Props<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, formState: { errors } }) => {
        const errorField = errors[name as keyof FieldErrors<T>];
        const error = errorField
          ? (errorField.message as string | undefined)
          : undefined;
        return (
          <>
            {label && (
              <label
                className={classNamesLib(
                  selectStyles.inputLabel,
                  classNames?.label
                )}
              >
                {label}
              </label>
            )}
            <div
              className={`flex flex-col gap-1 ${classNames?.warpper ? classNames.warpper : ""}`}
            >
              <div style={{ position: "relative" }}>
                <Select
                  onValueChange={onChange}
                  value={value != null ? value : ""}
                  disabled={disabled}
                >
                  <SelectTrigger
                    className={`
                  w-full py-[7px] h-[38px] border
                  border-[#C7D0D1] border-solid rounded-[10px] 
                  outline-none bg-[#FAFAFA] focus:ring-white 
                  ${classNames?.trigger}
                  `}
                    style={styles}
                  >
                    <SelectValue
                      placeholder={placeholder}
                      className="placeholder:text-[#577375]"
                    />
                  </SelectTrigger>
                  <SelectContent className={`z-[1000] ${classNames?.content}`}>
                    {options.map((item) => (
                      <SelectItem
                        value={item.value}
                        key={item.value}
                        disabled={item.disabled}
                      >
                        {item.text}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {value && !disabled && clearable && (
                  <button
                    type="button"
                    aria-label="Clear"
                    onClick={() => onChange("")}
                    style={{
                      position: "absolute",
                      right: "5px",
                      top: "50%",
                      transform: "translateY(-47%)",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "18px",
                      color: "#aaa",
                      padding: 0,
                      zIndex: 10,
                    }}
                    tabIndex={-1}
                  >
                    ×
                  </button>
                )}
              </div>
              {error && (
                <span
                  className={classNamesLib(
                    "text-red-500",
                    "text-sm",
                    classNames?.error
                  )}
                >
                  {error}
                </span>
              )}
            </div>
          </>
        );
      }}
    />
  );
};
